export const createID = () => `${Math.ceil(10 ** 4 * Math.random())}${Date.now()}`;
